import { equals } from 'ramda';

import { actionTypes } from './constants';
import { TRecentlyGamesAction, TRecentlyGamesState } from './types';

export const initialState: TRecentlyGamesState = {
    recentlyPlayedGames: [],
    recentlyPlayedLoaded: false,
    recentlyPlayedLoading: true
};

export const reducer = (state = initialState, action: TRecentlyGamesAction): TRecentlyGamesState => {
    switch (action.type) {
        case actionTypes.SET_RECENTLY_PLAYED: {
            return {
                ...state,
                recentlyPlayedGames: action.payload || [],
                recentlyPlayedLoading: false,
                recentlyPlayedLoaded: true
            };
        }
        case actionTypes.GAMES_PUSH: {
            if (action.payload.ID !== 31133) {
                return state;
            }

            const { tag, value } = action.payload.data?.notification?.notificationPlayerTagChangeInfo || {};

            if (tag !== 'uam/hidden/playerRecentGames') {
                return state;
            }

            const gameCodes = typeof value === 'string' ? JSON.parse(value) : value;
            const recentlyPlayedGames = gameCodes || [];

            if (equals(recentlyPlayedGames, state.recentlyPlayedGames)) {
                return state;
            }

            return {
                ...state,
                recentlyPlayedGames
            };
        }
        case actionTypes.RESET_RECENTLY_GAMES: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};
